<template>
	<div :aria-busy="loading ? 'true' : 'false'">
		<section class="content__custom" v-if="!loading">
			<div class="main-title">
				<h1 class="tickets">
					{{ 'tickets' | translate }}
				</h1>
				<h2>{{ 'ticketDetails-subtitle' | translate | capitalize }}</h2>
			</div>
			<div class="ticket-boxes">
				<div class="ticket-boxes__item ticket-boxes__ticket-info">
					<div class="ticket-boxes__user-info">
						<img :src="ticket.recipient.img || '/assets/images/avatar-recipient.jpg'" alt="">
						<h3>{{ ticket.recipient.name || $t('anonymous')}}</h3>
					</div>
					<ul class="ticket-boxes__ticket-details">
						<li>
							<span class="ticket-boxes__id">{{ 'ticket' | translate }}</span>
							<span>#{{ ticket.id }}</span>
						</li>
						<li>
							<span class="ticket-boxes__date">{{ 'requestDate' | translate }}</span>
							<span>{{ ticket.created_at | dateOnly }}</span>
						</li>
						<li v-if="(ticket.data || {}).cpf">
							<span class="ticket-boxes__document">{{ 'CPF' | translate }}</span>
							<span>{{ (ticket.data || {}).cpf }}</span>
						</li>
						<li v-if="(ticket.data || {}).mail">
							<span class="ticket-boxes__email">{{ 'email' | translate }}</span>
							<span>{{ (ticket.data || {}).mail }}</span>
						</li>
						<li v-else-if="(ticket.data || {}).email">
							<span class="ticket-boxes__email">{{ 'email' | translate }}</span>
							<span>{{ (ticket.data || {}).email }}</span>
						</li>
						<li v-if="(ticket.data || {}).productID">
							<span class="ticket-boxes__generic">{{ 'id' | translate }}</span>
							<span>{{ (ticket.data || {}).productID }}</span>
						</li>
						<li v-if="(ticket.data || {}).productName">
							<span class="ticket-boxes__generic">{{ 'productName' | translate }}</span>
							<span>{{ (ticket.data || {}).productName }}</span>
						</li>
						<li v-if="(ticket.data || {}).productQtd">
							<span class="ticket-boxes__generic">{{ 'quantity' | translate }}</span>
							<span>{{ (ticket.data || {}).productQtd }}</span>
						</li>
						<li v-if="(ticket.data || {}).totalPoints">
							<span class="ticket-boxes__generic">{{ 'totalPoints' | translate }}</span>
							<span>{{ (ticket.data || {}).totalPoints }}</span>
						</li>
						<li>
							<span class="ticket-boxes__type">{{ 'request' | translate }}</span>
							<span>{{ ticket.type.name }}</span>
						</li>

						<li v-if="ticket.attachments.length > 0">
							<span class="ticket-boxes__attachments">
								{{ 'attachments' | translate }}
							</span>
							<span class="ticket-boxes__attachment-list">
								<template v-for="(attachment, index) in ticket.attachments">
									<a :href="attachment.url" target="_blank">
										A{{ ++index }}
									</a>
								</template>
							</span>
						</li>
						<li v-if="(ticket.data || {}).description">
							<span class="ticket-boxes__description">{{ 'description' | translate }}</span>
							<textarea
								readonly
								id="description"
								v-model="(ticket.data || {}).description"
								name="description"
								cols="30"
								rows="10">
							</textarea>
						</li>
					</ul>
					<span v-if="1 !== 1" class="tickets__tag tickets__tag--details">
						{{ 'request' | translate }}
						{{ ticket.type.name }}
					</span>
				<div class="ticket-boxes__ticket-control">
						<form @submit.prevent="updateTicket">
							<div class="form__group">
								<label class="ticket-boxes__update-responsible">{{ 'taskAttr' | translate | capitalize }}</label>
								<select name="assignee" class="arrow-up" v-model="ticket.assignee.id">
									<option value="null" selected disabled>{{ 'ticketResponsibePlaceholder' | translate }}</option>
									<option v-for="user in users" :value="user.id" :key="user.id">
										{{ user.name }}
									</option>
								</select>
							</div>
							<div class="form__group form__group--two-columns">
								<label class="ticket-boxes__update-status">{{ 'ticketStatus' | translate | capitalize }}</label>
								<select name="assignee" class="arrow-up" v-model="ticket.status">
									<option value="" selected disabled>{{ 'ticketStatusPlaceholder' | translate | capitalize }}</option>
									<option v-for="status in statuses" :value="status.id" :key="status.id">
										{{ status.name }}
									</option>
								</select>
							</div>
							<div v-if="ticketUpdateSuccess" class="success" >
								<i class="fas fa-check"></i>
								{{ 'save-with-success' | translate | capitalize }}
							</div>
							<button type="submit" :disabled="this.controlLoading">
								{{ this.controlLoading
									? this.$options.filters.translate('saving')
									: this.$options.filters.translate('update')
								}}
							</button>
						</form>
					</div>
				</div>
				<div class="ticket-boxes__item ticket-boxes__item--tasks">
					<div class="ticket-boxes__item--messages">
							<div class="ticket-boxes__chat-container" ref="chatContainer">
								<div class="ticket-boxes__chat" v-for="(response, key) in ticket.response">
									<p>
										<span class="ticket-boxes__user-message">
											{{ $t('you') }}:
										</span>
										<span v-html="$options.filters.renderLineBreaks(response)"></span>
									</p>
									<p v-if="ticket.message[key]">
										<span class="ticket-boxes__user-message">
											{{ ticket.recipient.name }}
										</span>
										{{ ticket.message[key] }}
									</p>
								</div>
							</div>
						<form @submit.prevent="sendMessage">
								<div class="form__group form__group-relative">
									<label for="send-message" class="ticket-boxes__send-message">
										{{ 'answer' | translate | capitalize }}
									</label>
									<textarea
										id="send-message"
										maxlength="1000"
										v-model="ticketNewResponse"
										:disabled="this.selectedFile || !!ticket.anonymous">
									</textarea>
									<span id="counter-send-message" class="label pull-right bg-red counter"></span>
								</div>

								<div class="form__group submit__content">
									<button
										type="submit"
										:aria-busy="submitLoading ? 'true' : 'false'"
										:disabled="!!ticket.anonymous"
									>
										{{ this.messageLoading
											? this.$options.filters.translate('saving')
											: this.$options.filters.translate('send')
										}}
									</button>
								</div>
								<div v-if="sendMessageSuccess" class="success text-center" >
									<i class="fas fa-check"></i>
									{{ 'message-sent' | translate | capitalize }}
								</div>
								<div class="form__validation" v-show="apiError" v-for="(erro, index) in apiError" :key="index">
									<p><i class="fas fa-times-circle-o"></i> {{ erro | translate }}</p>
								</div>
							</form>
					</div>
				</div>

				<div class="ticket-boxes__logs">
						<div class="main-title">
							<h1 class="ticket-logs">
								{{ 'logs' | translate }}
							</h1>
							<h2>{{ 'logs-subtitle' | translate | capitalize }}</h2>
						</div>
						<table class="table-navigation" v-if="ticket.logs.length > 0">
						<thead>
							<tr>
								<th>{{ 'status' | translate | titleCase }}</th>
								<th>{{ 'description' | translate | titleCase }}</th>
								<th>{{ 'date-modification' | translate | titleCase }}</th>
								<th>{{ 'responsible' | translate | titleCase }}</th>
							</tr>
						</thead>

						<tbody>
							<tr
								v-for="log in ticket.logs"
								:key="log.id">
								<td :title="'action' | translate">
									<span
										class="tickets__tag"
										:class="`tickets__tag--${(log.data || {}).impact}`"
									>
										{{ (log.data || {}).status }}
									</span>
								</td>
								<td :title="'description' | translate">
									{{ log.text }}
								</td>
								<td :title="'date' | translate">
									{{ log.created_at | dateOnly }}
								</td>
								<td
									:title="'responsible' | translate"
									class="message-cell"
								>
									{{ (log.data || {}).user_name || 'noResponsible' | translate }}
								</td>
							</tr>
						</tbody>
					</table>
					<span v-else>
						{{ 'noData' | translate }}
					</span>
					</div>
			</div>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'ticketDetails',
		data() {
			return {
				users: '',
				usersLoading: true,
				statuses: [
					{
						id: 'pending',
						name: 'Aberto',
					},
					{
						id: 'progress',
						name: 'Em andamento',
					},
					{
						id: 'closed',
						name: 'Fechado',
					},
				],
				loading: true,
				controlLoading: false,
				messageLoading: false,
				newAssignee: '',
				ticketNewResponse: '',
				formRecipientToGroups: {},
				session: {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
					ticketId: this.$route.params.ticketId,
				},
				ticketUpdateSuccess: false,
				sendMessageSuccess: false,
				filterExists: false,
				response: {
					reply: '',
				},
				confirm: false,
				showAddToGroups: false,
				groupId: [],
				groupsFilterToSendNotification: [],
				errorMessage: '',
				fileName: '',
				attachmentType: '',
				type: '',
				imageData: '',
				apiError: false,
				selectedFile: null,
				submitLoading: false,
				validationError: false,
			};
		},
		computed: {
			ticket() {
				return this.$store.state.tickets.ticket;
			},
			error() {
				return this.$store.state.error;
			},
			user() {
				return this.$store.state.user;
			},
			success() {
				return this.$store.state.status;
			},
			sucessSetGroup() {
				return this.$store.state.detailsMessage;
			},
			groups() {
				return this.$store.state.group.groups.groups;
			},
		},
		watch: {
			ticket() {
				this.scrollChatToBottom();
			},
		},
		methods: {
			toggleLoading() {
				this.loading = !this.loading;
			},
			toggleSubmitLoading() {
				this.submitLoading = !this.submitLoading;
			},
			updateTicket() {
				this.controlLoading = true;
				const payload = { ...this.session, ...this.ticket };
				this.$store.dispatch('updateTicket', payload)
					.then(() => {
						this.controlLoading = false;
						this.ticketUpdateSuccess = this.success;
						setTimeout(() => {
							this.ticketUpdateSuccess = false;
						}, 5000);
					})
					.catch((err) => {
						this.controlLoading = false;
						console.error(err);
					});
			},
			sendMessage() {
				this.messageLoading = true;
				const payload = this.session;
				payload.response = this.ticketNewResponse || '';
				this.$store.dispatch('updateTicket', payload)
					.then(() => {
						this.messageLoading = false;
						this.sendMessageSuccess = this.success;

						setTimeout(() => {
							this.sendMessageSuccess = false;
						}, 5000);
						this.ticketNewResponse = '';
					})
					.catch((err) => {
						this.messageLoading = false;
						console.error(err);
					});
			},
			handleFileUpload(event) {
				const input = event.target;
				const reader = new FileReader();

				this.imageData = '';
				if (input.files && input.files[0]) {
					this.fileSize = event.target.files[0].size;

					if (event.target.files[0].size < 26214400) {
						this.type = 'attachment';
						[this.selectedFile] = event.target.files;
						this.fileName = event.target.files[0].name;

						if ((/(image)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'image';
							reader.onload = (e) => {
								this.imageData = e.target.result;
							};
							reader.readAsDataURL(input.files[0]);
						} else if ((/(audio)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'audio';
						} else if ((/(video)/i).test(event.target.files[0].type)) {
							this.attachmentType = 'video';
						} else {
							this.errorMessage = 'Formato inválido';
						}
					} else {
						this.errorMessage = 'O arquivo excede o tamanho máximo permitido';
						setTimeout(() => {
							this.errorMessage = '';
						}, 4000);
					}
				}
			},
			getFormData(object) {
				const formData = new FormData();
				Object.keys(object).forEach(key => formData.append(key, object[key]));
				return formData;
			},
			resetFile() {
				this.$refs.fileupload.value = '';
				this.selectedFile = null;
				this.imageData = '';
				this.type = '';
				this.attachment_type = '';
				this.fileName = '';
			},
			getTicket() {
				this.$store.dispatch('getTicket', this.session)
					.then(() => {
						this.toggleLoading();
					})
					.catch((err) => {
						this.toggleLoading();
						console.error(err);
					});
			},
			getUsers() {
				this.$store.dispatch('getUsers', this.session)
					.then((response) => {
						this.users = response.users;
						this.usersLoading = false;
					})
					.catch((err) => {
						this.usersLoading = false;
						console.error(err);
					});
			},
			toggleReadIssue() {
				if (this.issue.read === 0) {
					const payload = {};
					payload.read = 1;
					payload.issueId = this.$route.params.id;

					this.$store.dispatch('toggleReadIssue', payload);
				}

				if (this.issue.read === 1) {
					const payload = {};
					payload.read = 0;
					payload.issueId = this.$route.params.id;

					this.$store.dispatch('toggleReadIssue', payload);
					this.$router.push({ name: 'inbox' });
				}
			},
			scrollChatToBottom() {
				if (!this.$refs.chatContainer) {
					return;
				}
				this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight;
			},
		},
		mounted() {
			this.getTicket();
			this.getUsers();
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/tickets/ticketDetails.vue